import { createSelector } from 'reselect';
import _ from 'lodash';

export const customerSelector = state => state.customer.customer;

// for customer name and contact info
export const customerInfoSelector = createSelector(
  customerSelector,
  customer => ({
    streetAddress: _.get(customer, 'serviceAddress.streetAddress', ''),
    unitNumber: _.get(customer, 'serviceAddress.unitNumber', ''),
    city: _.get(customer, 'serviceAddress.city', ''),
    state: _.get(customer, 'serviceAddress.state', ''),
    zipCode: _.get(customer, 'serviceAddress.zipCode', ''),
    firstName: _.get(customer, 'firstName', ''),
    emailAddress: _.get(customer, 'emailAddress', ''),
    salesSessionId: _.get(customer, 'salesSessionId', '')
  })
);

// for user entered moveToAddress comparison
export const moveToAddressSelector = createSelector(
  customerSelector,
  customer => ({
    streetAddress1: _.get(customer, 'moveToAddress.streetAddress', null),
    unitNumber: _.get(customer, 'moveToAddress.unitNumber', null),
    zipCode: _.get(customer, 'moveToAddress.zipCode', null)
  })
);

// for min & max acceptable dates in move flow
export const moveDateRangeSelector = createSelector(
  customerSelector,
  customer => ({
    min: _.get(customer, 'moveStartDate', null),
    max: _.get(customer, 'moveEndDate', null)
  })
);

export const preferredTelephoneSelector = createSelector(
  customerSelector,
  customer => {
    const preferredTelephoneNumber = _.get(customer, 'preferredTelephoneNumber', '');
    const telephoneNumber = _.get(customer, 'telephoneNumber', '');

    return preferredTelephoneNumber || telephoneNumber;
  }
);


/** WEBPACK FOOTER **
 ** ./client/redux/modules/data/customer/selectors.js
 **/